import { getColor } from 'common/constants/_colors';
import { StyledMenuButton } from './EditDefaultsMenu.style';
import { getEditMenuItems } from './items';

const EditDefaultsMenu = props => {
  const { color } = props;
  const graphColor = getColor(color ?? 'dodgerBlue');
  const menuItems = getEditMenuItems({ ...props, graphColor });
  if (!menuItems.length) {
    return null;
  }
  return (
    <StyledMenuButton width='20rem' padding='x-x-x-small' items={menuItems} />
  );
};

export default EditDefaultsMenu;
